import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1.5),
    color: theme.palette.text.primary,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  argumentPaper: {
    padding: theme.spacing(2),
  },
  argumentHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.25),
    flexWrap: 'wrap',
  },
  category: {
    fontSize: '0.7rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  fieldLabel: {
    fontSize: '0.7rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: theme.palette.text.secondary,
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
    marginTop: theme.spacing(1.25),
  },
  excerpt: {
    fontSize: '0.85rem',
    color: theme.palette.text.primary,
    fontStyle: 'italic',
    lineHeight: 1.55,
    paddingLeft: theme.spacing(1.25),
    borderLeft: `2px solid ${theme.palette.divider}`,
  },
  rebuttal: {
    fontSize: '0.85rem',
    color: theme.palette.text.primary,
    lineHeight: 1.6,
  },
  refsRow: {
    display: 'flex',
    gap: theme.spacing(0.5),
    flexWrap: 'wrap',
  },
  legalChip: {
    fontSize: '0.7rem',
    height: 22,
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
    border: 'none',
    '& .MuiChip-icon': {
      color: theme.palette.primary.main,
      marginLeft: 6,
    },
  },
  evidenceChip: {
    fontSize: '0.7rem',
    height: 22,
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.primary,
    '& .MuiChip-icon': {
      color: theme.palette.text.secondary,
      marginLeft: 6,
    },
  },
  handbookBox: {
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1.25),
    border: `1px solid ${theme.palette.divider}`,
  },
  handbookLabel: {
    fontSize: '0.7rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: theme.palette.text.secondary,
    fontWeight: 600,
    marginBottom: theme.spacing(0.25),
  },
  handbookText: {
    fontSize: '0.8rem',
    color: theme.palette.text.primary,
    lineHeight: 1.5,
  },
}))

export default useStyles
